import searchSynonyms from "./searchSynonyms.json";

let synonymService = function() {
    //---------------------------------------------------------------------------
    //
    //                           Public Methods
    //
    //---------------------------------------------------------------------------
    let publicMethods = {
        /**
         * Get any existing synonym for the search term
         * @param searchTerm - Examples: "age lock", "agelock", "dramatic"
         *
         * @returns The synonym for the term to be searched if it exists.  Returns the original search term if there are no synonyms
         */
        getSynonym: function(searchTerm) {
            return searchSynonyms[searchTerm] || searchTerm;
        }
    };

    return publicMethods;
}();

export default synonymService;